import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/styles';
import Typography from '@material-ui/core/Typography';
import NoSsr from '@material-ui/core/NoSsr';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Chip from '@material-ui/core/Chip';
import MenuItem from '@material-ui/core/MenuItem';
import CancelIcon from '@material-ui/icons/Cancel';
import AsyncSelect from 'react-select/lib/Async';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
  },
  input: {
    display: 'flex',
    padding: 0,
  },
  valueContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    flex: 1,
    alignItems: 'center',
    overflow: 'hidden',
  },
  chip: {
    margin: '20px 10px',
  },
  noOptionsMessage: {
    padding: '10px 20px',
  },
  singleValue: {
    fontSize: 14,
  },
  placeholder: {
    position: 'absolute',
    left: 2,
    fontSize: 14,
  },
  paper: {
    position: 'absolute',
    zIndex: 999,
    marginTop: '20px',
    left: 0,
    right: 0,
  },
  divider: {
    height: '20px',
  },
}));

// eslint-disable-next-line func-style -- FIXME
function NoOptionsMessage(props) {
  const { t } = useTranslation();
  const { idSearch, inputValue } = props.selectProps;
  const isNumericInput = /^\d+$/.test(`${inputValue ?? ''}`.trim());

  const message =
    idSearch && isNumericInput
      ? t(
          'components.formSelectDropDown.noDishWithId',
          'Brak dania o podanym ID'
        )
      : t('components.formSelectDropDown.nameEnter', 'Wpisz nazwę');

  return (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.noOptionsMessage}
      {...props.innerProps}
    >
      {message}
    </Typography>
  );
}

// eslint-disable-next-line func-style -- FIXME
function inputComponent({ inputRef, ...props }) {
  return <div ref={inputRef} {...props} />;
}

// eslint-disable-next-line func-style -- FIXME
function Control(props) {
  return (
    <TextField
      fullWidth={true}
      InputProps={{
        inputComponent,
        inputProps: {
          className: props.selectProps.classes.input,
          inputRef: props.innerRef,
          children: props.children,
          ...props.innerProps,
        },
      }}
      {...props.selectProps.textFieldProps}
    />
  );
}

// eslint-disable-next-line func-style -- FIXME
function Option(props) {
  return (
    <MenuItem
      buttonRef={props.innerRef}
      selected={props.isFocused}
      component="div"
      style={{
        height: 'auto',
        fontSize: '14px',
        fontWeight: props.isSelected ? 500 : 400,
        whiteSpace: 'normal',
      }}
      {...props.innerProps}
    >
      {props.children}
    </MenuItem>
  );
}

// eslint-disable-next-line func-style -- FIXME
function Placeholder(props) {
  return (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.placeholder}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

// eslint-disable-next-line func-style -- FIXME
function SingleValue(props) {
  return (
    <Typography
      className={props.selectProps.classes.singleValue}
      {...props.innerProps}
    >
      {props.children}
      {!props.isDisabled && !props.isMulti && props.hasValue && (
        <div
          style={{
            background: '#fff',
            position: 'absolute',
            cursor: 'pointer',
            right: '38px',
            top: '50%',
            transform: 'translateY(-50%)',
            zIndex: '2',
            borderLeft: '1px solid',
            padding: '2px 10px',
            color: '#ababab',
          }}
          onClick={() => props.setValue(null)}
        >
          X
        </div>
      )}
    </Typography>
  );
}

// eslint-disable-next-line func-style -- FIXME
function ValueContainer(props) {
  return (
    <div
      className={props.selectProps.classes.valueContainer}
      style={{ psoition: 'relative' }}
    >
      {props.children}
    </div>
  );
}

// eslint-disable-next-line func-style -- FIXME
function MultiValue(props) {
  return (
    <Chip
      tabIndex={-1}
      label={props.children}
      className={classNames(props.selectProps.classes.chip)}
      onDelete={props.removeProps.onClick}
      deleteIcon={<CancelIcon {...props.removeProps} />}
    />
  );
}

// eslint-disable-next-line func-style -- FIXME
function Menu(props) {
  return (
    <Paper
      square={true}
      className={props.selectProps.classes.paper}
      {...props.innerProps}
    >
      {props.children}
    </Paper>
  );
}

const components = {
  Control,
  Menu,
  MultiValue,
  NoOptionsMessage,
  Option,
  Placeholder,
  SingleValue,
  ValueContainer,
};

// eslint-disable-next-line func-style -- FIXME
function FormSelectDropdown({
  handleClick,
  filter,
  clearAfterSelect,
  filterName,
  filterValue,
  includeWorkName,
  placeholder,
  includeId,
  idSearch,
  value,
}) {
  const classes = useStyles();

  const [typingTimeout, setTypingTimeout] = useState(null);
  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [val, setVal] = useState(value ?? null);

  // eslint-disable-next-line func-style, no-shadow -- FIXME
  function handleChangeSingle(value) {
    setVal(value);
    handleClick(value);

    if (clearAfterSelect) {
      setVal(null);
      setInputValue('');
    }
  }

  useEffect(() => {
    setVal(value);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIXME
  }, [JSON.stringify(value)]);

  const selectStyles = {
    input: base => ({
      ...base,
      color: 'black',
      '& input': {
        font: 'inherit',
      },
    }),
  };

  // eslint-disable-next-line no-shadow, promise/prefer-await-to-callbacks -- FIXME
  const loadWithTimeout = (inputValue, callback) => {
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    // eslint-disable-next-line no-use-before-define -- FIXME
    setTypingTimeout(setTimeout(() => loadOptions(inputValue, callback), 400));
  };

  // eslint-disable-next-line no-shadow, promise/prefer-await-to-callbacks -- FIXME
  const loadOptions = (inputValue, callback) => {
    const filterNameFromProps = filterName || 'name';
    const filterValueFromProps = filterValue || 'name';

    return (
      filter(inputValue)
        // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
        .then(async x => {
          const filteredOptions = x.map(el => {
            let label;
            // eslint-disable-next-line no-shadow -- FIXME
            let value;
            if (typeof filterNameFromProps === 'function') {
              label = filterNameFromProps(el);
            } else {
              label = includeId ? `(${el.id}) ` : '';
              label += `${el[filterNameFromProps]}`;
              label += includeWorkName ? ` (${el.workName})` : '';
            }
            if (typeof filterValueFromProps === 'function') {
              value = filterValueFromProps(el);
            } else {
              value = el[filterNameFromProps];
            }
            return {
              ...el,
              label,
              value,
            };
          });
          await setOptions(filteredOptions);
          return filteredOptions;
        })
        // eslint-disable-next-line promise/prefer-await-to-then, promise/prefer-await-to-callbacks -- FIXME
        .then(c => callback(c))
    );
  };

  return (
    <div className={classes.root}>
      <NoSsr>
        <AsyncSelect
          loadOptions={loadWithTimeout}
          defaultOptions={options}
          classes={classes}
          styles={selectStyles}
          components={components}
          onChange={handleChangeSingle}
          value={val}
          idSearch={idSearch}
          inputValue={inputValue}
          // eslint-disable-next-line no-shadow -- FIXME
          onInputChange={value => setInputValue(value)}
          placeholder={placeholder || 'Dodaj'}
        />
        <div className={classes.divider} />
      </NoSsr>
    </div>
  );
}

export default FormSelectDropdown;
